module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_kasi_m.dc64fa7013d5eb5fedf359279560ab0a.png";